import React from "react";
import TabelSentS4 from "./TabelSentS4";
function MainSent90CEOToS4() {
  return (
    <>
      <TabelSentS4></TabelSentS4>
    </>
  );
}
export default MainSent90CEOToS4;
